class LoyaltyPoints extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['points']
  }

  setupListeners () {
    super.setupListeners()

    this.els.points.element.setAttribute('aria-busy', true)

    this.getDetails = this.getDetails.bind(this)

    document.addEventListener('swell:setup', () => {
      this.getDetails()
    })
  }

  getDetails () {
    /* eslint-disable-next-line no-undef */
    const customerDetails = swellAPI.getCustomerDetails()
    const customerPointsBalance = customerDetails.pointsBalance

    this.els.points.element.innerText = customerPointsBalance
    this.els.points.element.setAttribute('aria-busy', false)
  }
}

if (!customElements.get('loyalty-points')) {
  customElements.define('loyalty-points', LoyaltyPoints)
}
